import BaseModel from '../core/BaseModel'
export default class WarrantyRepairProductSerialNumberModel extends BaseModel {
    constructor() {
        super({ 
                name: "warranty_repair_product_serial_number",
                tableName: 'core_warranty_repair_product_serial_number'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            fied_detail: {
                refs: 'request_return_product_id service_total_price_payment service_money_tax service_tax service_total_money_discount service_total_discount service_total_price_service check_list_img_records_confirm check_staff_comments check_type_failure_cause_id check_result check_reason_not_repairing check_reason_cancel_product check_content_ask_customer check_is_customer_reply check_technical_user_id check_cause_damage check_proposed_solutions check_presently_damaged check_maintenance_period check_type_service warranty_repair_id type_service desc_status_product list_img_status_product process_status info_customer_product_serial_number  serial_number_id obj_warranty_repair { code process_status receive_day_reception obj_modifier { id full_name organization_account { organization_id organization { name id } } }  } product_serial_number{ serial_number product_id } ',
                display: false
            },
        },)
    }

}